import styles from "./FindPerfectMentor.module.css";
import FindMentorFooterImg from "../../../assets/images/FindMentorFooterImg.png";
import { Link } from "react-router-dom";

export default function FindPerfectMentor() {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.footerTopOuter}>
          <div className={styles.left}>
            <h3>
              Find Your Perfect <span>Mentor Match</span>
            </h3>
            <p>
              Browse our network of expert mentors or let us help you find the
              right fit for your goals.
            </p>

            <div className={styles.buttonSection}>
              <Link className={styles.orangeButton} to="/">
                Browse All Mentors
              </Link>
              <Link className={styles.blueButton} to="/">
                Custom Matching
              </Link>
            </div>
          </div>
          <div className={styles.right}>
            <img src={FindMentorFooterImg} alt="FindMentorFooterImg" />
          </div>
        </div>
      </div>
    </footer>
  );
}
